export function OnlyLetters(event: any) {
  let code = event.which
  if ((code >= 65 && code <= 90) || (code >= 97 && code <= 122) || code == 32) return true;
  else return false;
}